import { axiosInstanceV2 } from "./axios";

export const getPlans = () => {
    let url = "/agreement-plans/";
    return axiosInstanceV2.get(url).then(({ data }) => data.results);
};
